module.exports = __webpack_public_path__ + "img/top_info_title.819c2e3c.png";